import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy loading de componentes - usando named exports correctamente
const MapaInteractivoPage = lazy(() => import('@feature/monitor').then(m => ({ default: m.MapaInteractivoPage })));
const UmbralRiesgoSettings = lazy(() => import('@feature/monitor').then(m => ({ default: m.UmbralRiesgoSettings })));
const EdithUmbralRiesgo = lazy(() => import('@feature/monitor').then(m => ({ default: m.EdithUmbralRiesgo })));
const CentreMonitor = lazy(() => import('@feature/monitor').then(m => ({ default: m.CentreMonitor })));
import { ROUTES } from '@shared/constants/routes.constants';

/**
 * Rutas principales de la aplicación
 */
export const mapRoutes: RouteObject[] = [
  {
    path: ROUTES.MAIN.MAP,
    element: <MapaInteractivoPage />,
  },
  {
    path: ROUTES.MAP.THRESHOLD,
    element: <UmbralRiesgoSettings />,
  },
  {
    path: ROUTES.MAP.MONITOR,
    element: <CentreMonitor />,
  },
  {
    path: ROUTES.MAP.EDIT_THRESHOLD.STORM,
    element: <EdithUmbralRiesgo phenomenType={"storm"} />,
  },
  {
    path: ROUTES.MAP.EDIT_THRESHOLD.WIND,
    element: <EdithUmbralRiesgo phenomenType={"wind"} />,
  },
  {
    path: ROUTES.MAP.EDIT_THRESHOLD.FLOOD,
    element: <EdithUmbralRiesgo phenomenType={"flood"} />,
  },
  {
    path: ROUTES.MAP.EDIT_THRESHOLD.FROST,
    element: <EdithUmbralRiesgo phenomenType={"frost"} />,
  },
  {
    path: ROUTES.MAP.EDIT_THRESHOLD.HIGH_TEMPERATURES,
    element: <EdithUmbralRiesgo phenomenType={"high_temperatures"} />,
  },
  {
    path: ROUTES.MAP.EDIT_THRESHOLD.LOW_TEMPERATURES,
    element: <EdithUmbralRiesgo phenomenType={"low_temperatures"} />,
  },
  
];
